module.exports = __webpack_public_path__ + "img/emoji-29.68203842.png";